import { useMutation } from "@tanstack/react-query";
import i18next from "i18next";
import { ApiFortAgentPurchaseSign } from "@/api";
import {
  FortAgentPurchaseResultCode,
  type FortAgentPurchaseSignRequest,
} from "@/api/types";
import { showError } from "@/lib/toast";
import { getTokenName } from "@/config/common";
import { CCC_FUSD_ADDRESS, USDT_ADDRESS } from "@/config/env";

export function useFortAgentPurchaseSign() {
  return useMutation({
    mutationFn: async (data: FortAgentPurchaseSignRequest) => {
      console.log("useFortAgentPurchaseSign", data);
      const res = await ApiFortAgentPurchaseSign(data);
      console.log("useFortAgentPurchaseSign", res.data);
      return res.data;
    },
    onSuccess: data => {
      const code = data.resultCode;
      if (code === FortAgentPurchaseResultCode.Success) return null;
      showError(
        i18next.t(
          FORT_AGENT_PURCHASE_RESULT_I18N_KEY[
            code as keyof typeof FORT_AGENT_PURCHASE_RESULT_I18N_KEY
          ],
          {
            tokenName: getTokenName(CCC_FUSD_ADDRESS),
            tokenNameUsdt: getTokenName(USDT_ADDRESS),
          }
        )
      );
    },
    onError: () => {},
  });
}
/** 与 {@link FortAgentPurchaseResultCode} 一一对应的 i18n key（toast.fortAgent.purchase.result.*） */
export const FORT_AGENT_PURCHASE_RESULT_I18N_KEY: Record<
  Exclude<FortAgentPurchaseResultCode, FortAgentPurchaseResultCode.Success>,
  string
> = {
  [FortAgentPurchaseResultCode.InvalidPaymentMethod]:
    "toast.fortAgent.purchase.result.invalidPaymentMethod",
  [FortAgentPurchaseResultCode.InvalidSkuOrDisabled]:
    "toast.fortAgent.purchase.result.invalidSkuOrDisabled",
  [FortAgentPurchaseResultCode.WalletNotBound]:
    "toast.fortAgent.purchase.result.walletNotBound",
  [FortAgentPurchaseResultCode.RecipientInvalid]:
    "toast.fortAgent.purchase.result.recipientInvalid",
  [FortAgentPurchaseResultCode.RecipientSameAsBuyer]:
    "toast.fortAgent.purchase.result.recipientSameAsBuyer",
  [FortAgentPurchaseResultCode.SkuNotStarted]:
    "toast.fortAgent.purchase.result.skuNotStarted",
  [FortAgentPurchaseResultCode.SkuExpired]:
    "toast.fortAgent.purchase.result.skuExpired",
  [FortAgentPurchaseResultCode.PriceCalculationFailed]:
    "toast.fortAgent.purchase.result.priceCalculationFailed",
  [FortAgentPurchaseResultCode.UsdtConfigError]:
    "toast.fortAgent.purchase.result.usdtConfigError",
  [FortAgentPurchaseResultCode.SignServiceRejected]:
    "toast.fortAgent.purchase.result.signServiceRejected",
  [FortAgentPurchaseResultCode.MixedRatioConfigError]:
    "toast.fortAgent.purchase.result.mixedRatioConfigError",
  [FortAgentPurchaseResultCode.SoldOut]:
    "toast.fortAgent.purchase.result.soldOut",
  [FortAgentPurchaseResultCode.UserDoesNotSupportMixed]:
    "toast.fortAgent.purchase.result.userDoesNotSupportMixed",
  [FortAgentPurchaseResultCode.PendingPurchaseSignature]:
    "toast.fortAgent.purchase.result.pendingPurchaseSignature",
  [FortAgentPurchaseResultCode.InvalidQuantity]:
    "toast.fortAgent.purchase.result.invalidQuantity",
  [FortAgentPurchaseResultCode.InsufficientMixedFusdGameNow]:
    "toast.fortAgent.purchase.result.insufficientMixedFusdGameNow",
  [FortAgentPurchaseResultCode.InsufficientMixedFusdWaitNow]:
    "toast.fortAgent.purchase.result.insufficientMixedFusdWaitNow",
  [FortAgentPurchaseResultCode.MixedNowFusdDeductNotApplied]:
    "toast.fortAgent.purchase.result.mixedNowFusdDeductNotApplied",
};
